<template>
    <div class="dhf-overlay">
        <div class="dhf-overlay__backdrop" @click="$emit('close-modal')" />
        <div class="dhf-overlay__container">
            <focus-trap>
                <div class="dhf-overlay__container-wrapper">
                    <button class="dhf-overlay__container-wrapper-closeBtn" @click="emits('close-modal')">
                        <DhfIcon name="cross" :width="18" :height="18" class="dhf-modal-icon" />
                    </button>
                    <slot></slot>
                </div>
            </focus-trap>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import DhfIcon from '@/components/dhf-icon/dhf-icon.vue';
import { FocusTrap } from 'focus-trap-vue';

const emits = defineEmits(['close-modal']);
const scrollPos = window.pageYOffset;
const scrollThreshold = 100;

const handleScroll = () => {
    const scrolled = window.scrollY;
    // overlay should get closed when user scrolls too far
    if (scrolled < scrollPos - scrollThreshold || scrolled > scrollPos + scrollThreshold) {
        emits('close-modal');
    }
};

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
    document.removeEventListener('scroll', handleScroll);
});
</script>

<style lang="scss" scoped>
@import './dhf-overlay.scss';
</style>
